import React from 'react';
import { connect } from 'react-redux';
import { View, Text } from 'react-native';

import AudioMessage from './AudioMessage';
import { detectURL } from '../../../functions';
import styles from '../../../styles';
import { global } from '../../../const';


class SendMessage extends React.Component {

    render() {
        let { message, type, id, kind, riddle_key } = this.props.data;
        if (Number(type) === 0) message = detectURL(message)
        if (Number(type) === 2) {
            let voiceMsg = message.split('^');
            voiceMsg = voiceMsg[0] || 0;
            if (!Number(voiceMsg)) voiceMsg = 0;
            // if (voiceMsg === 0) return null;
        }
        return (
            <View style={{ flexDirection: 'row', marginVertical: 1, alignSelf: 'flex-end' }} key={id}>

                {
                    Number(type) === 2 ?
                        <AudioMessage
                            type={1}
                            url={message}
                            id={global.database + id}
                            kind={Number(kind)}
                            ans={riddle_key}
                            redius={this.props.redius}
                        />
                        :
                        <View style={[styles.msgContainerSend, styles.bgBlue, { borderTopRightRadius: this.props.redius === null ? 20 : 3 }]} >

                            <Text style={{ color: '#fff', fontFamily: 'NotoSans-Regular', fontSize: 15, maxWidth: 275 }} dangerouslySetInnerHTML={{ __html: message }} />

                        </View>
                }
            </View>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        userInfo: auth.userInfo
    };
}
export default connect(mapStateToProps)(SendMessage);